import { render } from "./FormCAT.vue?vue&type=template&id=8a275b86&scoped=true"
import script from "./FormCAT.vue?vue&type=script&lang=js"
export * from "./FormCAT.vue?vue&type=script&lang=js"

import "./FormCAT.vue?vue&type=style&index=0&id=8a275b86&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a275b86"]])

export default __exports__